import { DiCss3 } from "react-icons/di";
import { IoLogoJavascript, IoLogoNodejs } from "react-icons/io";
import { IoLogoReact } from "react-icons/io5";
import { SiNextdotjs, SiPostgresql, SiTailwindcss } from "react-icons/si";

export const technologiesTooltips = [
    {
        icon: DiCss3,
        text: 'CSS'
    },
    {
        icon: IoLogoJavascript,
        text: 'JavaScript'
    },
    {
        icon: IoLogoNodejs,
        text: 'Node.js'
    },
    {
        icon: IoLogoReact,
        text: 'React'
    },
    {
        icon: SiNextdotjs,
        text: 'Next.js'
    },
    {
        icon: SiTailwindcss,
        text: 'Tailwind'
    },
    {
        icon: SiPostgresql,
        text: 'PostgreSQL'
    }

];